import { blocks, view, constraints } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import getClosestBlockElement from 'src/js/modules/common/helpers/get-closest-block-element';

const {
  trackers: { trackEvent },
  constants,
} = segment;

const trackDuplicateCompositeItem = ({ elementId }) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const block = getClosestBlockElement(liveElement);
  const blockId = blocks.accessors.getBlockIdByElement(block);
  const blockVariationId = blocks.accessors.getVariationIdByElement(block);
  const constraint = constraints.filters.findFirstFor(liveElement);

  trackEvent(constants.events.WIDGET_DUPLICATED, {
    targetBlockId: blockId,
    targetBlockVariationId: blockVariationId,
    blockId: null,
    blockVariationId: null,
    constraintId: constraint?.id,
  });
};

export default trackDuplicateCompositeItem;
